module.exports = __webpack_public_path__ + "img/btn_download.f7736c91.svg";